export default "__VITE_ASSET__3X7o4uDV__"